import Vue from 'vue'
export default ({ app }, inject) => {
    const overlays = {}
    // Only one overlay may be shown at a time
    const state = Vue.observable({ activeOverlay: null })

    inject('overlay', {
        // By registering an Overlay we are saying we want it to be added to the URL
        registerUrlKey(key, options = {}) {
            const { isPersistent = false } = options

            overlays[key] = {
                isPersistent,
            }
        },
        show(key) {
            // Detect when we have a modal open but we want a new one
            if (state.activeOverlay !== null && state.activeOverlay !== key) {
                this.hide()
                // We need to allow the CSS transitions to finish before firing
                // a new modal
                setTimeout(() => {
                    state.activeOverlay = key
                }, 0)
                return
            }

            state.activeOverlay = key
        },
        hide() {
            state.activeOverlay = null
        },
        addQuery(key, currentRoute) {
            if (currentRoute.query && currentRoute.query.mod === key) return

            // Only add to the URL if the modal is registered
            if (overlays[key]) {
                const query = Object.assign({}, currentRoute.query, { mod: key })
                const params = Object.assign({}, currentRoute.params, { noUpdateScroll: true })
                updateUrl(currentRoute, query, params)
            }
        },
        removeQuery(currentRoute) {
            const query = Object.assign({}, currentRoute.query)
            if (!query.mod) return
            const params = Object.assign({}, currentRoute.params, { noUpdateScroll: true })

            delete query.mod
            updateUrl(currentRoute, query, params)
        },
        state,
    })

    app.router.afterEach((to) => {
        if (app.$device.isDesktop && overlays[state.activeOverlay]?.isPersistent) return

        if (!to.query.mod) app.$overlay.hide()
        else {
            app.$overlay.show(to.query.mod)
        }
    })

    function updateUrl(currentRoute, query, params) {
        if (currentRoute.name !== 'cms') app.$push.to({ query, params })
        else app.$push.to({ path: currentRoute.path, query })
    }
}
